import "./DisplayProgressCircles.css";

export type DisplayProgressCirclesType = {
    n?: number;
    colors?: string[];
    style?: React.CSSProperties;
    containerClassName?: string;
    containerStyle?: React.CSSProperties;
}

const DisplayProgressCircles = ({ n=3, colors=['#C66', '#6C6', '#66C'], style={ width: '28px', height: '28px' }, containerClassName = '', containerStyle = {} } : DisplayProgressCirclesType) => {
    const circles = [];

    for (let i = 0; i < n; ++i) {
        circles.push(<div key={i} className="circularProcressLoader" style={{ borderColor: i < colors.length ? colors[i] : colors[i%colors.length], ...style }} />);
    }

    return (<div className={`flex items-center justify-center gap-4 ${containerClassName}`} style={containerStyle}> {circles} </div>);
}

export default DisplayProgressCircles;